module.exports = __webpack_public_path__ + "img/Abschied.c94c6806.jpg";